import _objectSpread from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/mireland/hrecos-redux/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["refetchPage"];
import { shallowEqualObjects, noop, isServer, isValidTimeout, timeUntilStale, replaceData } from './utils.esm.js';
import { notifyManager } from './notifyManager.esm.js';
import { focusManager } from './focusManager.esm.js';
import { Subscribable } from './subscribable.esm.js';
import { canFetch, isCancelledError } from './retryer.esm.js';
var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  _inherits(QueryObserver, _Subscribable);
  var _super = _createSuper(QueryObserver);
  function QueryObserver(client, options) {
    var _this;
    _classCallCheck(this, QueryObserver);
    _this = _super.call(this);
    _this.client = client;
    _this.options = options;
    _this.trackedProps = new Set();
    _this.selectError = null;
    _this.bindMethods();
    _this.setOptions(options);
    return _this;
  }
  _createClass(QueryObserver, [{
    key: "bindMethods",
    value: function bindMethods() {
      this.remove = this.remove.bind(this);
      this.refetch = this.refetch.bind(this);
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {
      if (this.listeners.length === 1) {
        this.currentQuery.addObserver(this);
        if (shouldFetchOnMount(this.currentQuery, this.options)) {
          this.executeFetch();
        }
        this.updateTimers();
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.listeners.length) {
        this.destroy();
      }
    }
  }, {
    key: "shouldFetchOnReconnect",
    value: function shouldFetchOnReconnect() {
      return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
  }, {
    key: "shouldFetchOnWindowFocus",
    value: function shouldFetchOnWindowFocus() {
      return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners = [];
      this.clearStaleTimeout();
      this.clearRefetchInterval();
      this.currentQuery.removeObserver(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options, notifyOptions) {
      var prevOptions = this.options;
      var prevQuery = this.currentQuery;
      this.options = this.client.defaultQueryOptions(options);
      if (process.env.NODE_ENV !== 'production' && typeof (options == null ? void 0 : options.isDataEqual) !== 'undefined') {
        this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option");
      }
      if (!shallowEqualObjects(prevOptions, this.options)) {
        this.client.getQueryCache().notify({
          type: 'observerOptionsUpdated',
          query: this.currentQuery,
          observer: this
        });
      }
      if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
        throw new Error('Expected enabled to be a boolean');
      } // Keep previous query key if the user does not supply one

      if (!this.options.queryKey) {
        this.options.queryKey = prevOptions.queryKey;
      }
      this.updateQuery();
      var mounted = this.hasListeners(); // Fetch if there are subscribers

      if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
        this.executeFetch();
      } // Update result

      this.updateResult(notifyOptions); // Update stale interval if needed

      if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
        this.updateStaleTimeout();
      }
      var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

      if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
        this.updateRefetchInterval(nextRefetchInterval);
      }
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(options) {
      var query = this.client.getQueryCache().build(this.client, options);
      return this.createResult(query, options);
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return this.currentResult;
    }
  }, {
    key: "trackResult",
    value: function trackResult(result) {
      var _this2 = this;
      var trackedResult = {};
      Object.keys(result).forEach(function (key) {
        Object.defineProperty(trackedResult, key, {
          configurable: false,
          enumerable: true,
          get: function get() {
            _this2.trackedProps.add(key);
            return result[key];
          }
        });
      });
      return trackedResult;
    }
  }, {
    key: "getCurrentQuery",
    value: function getCurrentQuery() {
      return this.currentQuery;
    }
  }, {
    key: "remove",
    value: function remove() {
      this.client.getQueryCache().remove(this.currentQuery);
    }
  }, {
    key: "refetch",
    value: function refetch() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        refetchPage = _ref.refetchPage,
        options = _objectWithoutProperties(_ref, _excluded);
      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          refetchPage: refetchPage
        }
      }));
    }
  }, {
    key: "fetchOptimistic",
    value: function fetchOptimistic(options) {
      var _this3 = this;
      var defaultedOptions = this.client.defaultQueryOptions(options);
      var query = this.client.getQueryCache().build(this.client, defaultedOptions);
      query.isFetchingOptimistic = true;
      return query.fetch().then(function () {
        return _this3.createResult(query, defaultedOptions);
      });
    }
  }, {
    key: "fetch",
    value: function fetch(fetchOptions) {
      var _this4 = this;
      var _fetchOptions$cancelR;
      return this.executeFetch(_objectSpread(_objectSpread({}, fetchOptions), {}, {
        cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
      })).then(function () {
        _this4.updateResult();
        return _this4.currentResult;
      });
    }
  }, {
    key: "executeFetch",
    value: function executeFetch(fetchOptions) {
      // Make sure we reference the latest query as the current one might have been removed
      this.updateQuery(); // Fetch

      var promise = this.currentQuery.fetch(this.options, fetchOptions);
      if (!(fetchOptions != null && fetchOptions.throwOnError)) {
        promise = promise.catch(noop);
      }
      return promise;
    }
  }, {
    key: "updateStaleTimeout",
    value: function updateStaleTimeout() {
      var _this5 = this;
      this.clearStaleTimeout();
      if (isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime)) {
        return;
      }
      var time = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
      // To mitigate this issue we always add 1 ms to the timeout.

      var timeout = time + 1;
      this.staleTimeoutId = setTimeout(function () {
        if (!_this5.currentResult.isStale) {
          _this5.updateResult();
        }
      }, timeout);
    }
  }, {
    key: "computeRefetchInterval",
    value: function computeRefetchInterval() {
      var _this$options$refetch;
      return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
  }, {
    key: "updateRefetchInterval",
    value: function updateRefetchInterval(nextInterval) {
      var _this6 = this;
      this.clearRefetchInterval();
      this.currentRefetchInterval = nextInterval;
      if (isServer || this.options.enabled === false || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
        return;
      }
      this.refetchIntervalId = setInterval(function () {
        if (_this6.options.refetchIntervalInBackground || focusManager.isFocused()) {
          _this6.executeFetch();
        }
      }, this.currentRefetchInterval);
    }
  }, {
    key: "updateTimers",
    value: function updateTimers() {
      this.updateStaleTimeout();
      this.updateRefetchInterval(this.computeRefetchInterval());
    }
  }, {
    key: "clearStaleTimeout",
    value: function clearStaleTimeout() {
      if (this.staleTimeoutId) {
        clearTimeout(this.staleTimeoutId);
        this.staleTimeoutId = undefined;
      }
    }
  }, {
    key: "clearRefetchInterval",
    value: function clearRefetchInterval() {
      if (this.refetchIntervalId) {
        clearInterval(this.refetchIntervalId);
        this.refetchIntervalId = undefined;
      }
    }
  }, {
    key: "createResult",
    value: function createResult(query, options) {
      var prevQuery = this.currentQuery;
      var prevOptions = this.options;
      var prevResult = this.currentResult;
      var prevResultState = this.currentResultState;
      var prevResultOptions = this.currentResultOptions;
      var queryChange = query !== prevQuery;
      var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
      var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
      var state = query.state;
      var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        fetchStatus = state.fetchStatus,
        status = state.status;
      var isPreviousData = false;
      var isPlaceholderData = false;
      var data; // Optimistically set result in fetching state if needed

      if (options._optimisticResults) {
        var mounted = this.hasListeners();
        var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
        var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
        if (fetchOnMount || fetchOptionally) {
          fetchStatus = canFetch(query.options.networkMode) ? 'fetching' : 'paused';
          if (!dataUpdatedAt) {
            status = 'loading';
          }
        }
        if (options._optimisticResults === 'isRestoring') {
          fetchStatus = 'idle';
        }
      } // Keep previous data if needed

      if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
        data = prevQueryResult.data;
        dataUpdatedAt = prevQueryResult.dataUpdatedAt;
        status = prevQueryResult.status;
        isPreviousData = true;
      } // Select data if needed
      else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);
            data = replaceData(prevResult == null ? void 0 : prevResult.data, data, options);
            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            if (process.env.NODE_ENV !== 'production') {
              this.client.getLogger().error(selectError);
            }
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
        data = state.data;
      } // Show placeholder data if needed

      if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
        var placeholderData; // Memoize placeholder data

        if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
          placeholderData = prevResult.data;
        } else {
          placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
          if (options.select && typeof placeholderData !== 'undefined') {
            try {
              placeholderData = options.select(placeholderData);
              this.selectError = null;
            } catch (selectError) {
              if (process.env.NODE_ENV !== 'production') {
                this.client.getLogger().error(selectError);
              }
              this.selectError = selectError;
            }
          }
        }
        if (typeof placeholderData !== 'undefined') {
          status = 'success';
          data = replaceData(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
          isPlaceholderData = true;
        }
      }
      if (this.selectError) {
        error = this.selectError;
        data = this.selectResult;
        errorUpdatedAt = Date.now();
        status = 'error';
      }
      var isFetching = fetchStatus === 'fetching';
      var isLoading = status === 'loading';
      var isError = status === 'error';
      var result = {
        status: status,
        fetchStatus: fetchStatus,
        isLoading: isLoading,
        isSuccess: status === 'success',
        isError: isError,
        isInitialLoading: isLoading && isFetching,
        data: data,
        dataUpdatedAt: dataUpdatedAt,
        error: error,
        errorUpdatedAt: errorUpdatedAt,
        failureCount: state.fetchFailureCount,
        failureReason: state.fetchFailureReason,
        errorUpdateCount: state.errorUpdateCount,
        isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
        isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
        isFetching: isFetching,
        isRefetching: isFetching && !isLoading,
        isLoadingError: isError && state.dataUpdatedAt === 0,
        isPaused: fetchStatus === 'paused',
        isPlaceholderData: isPlaceholderData,
        isPreviousData: isPreviousData,
        isRefetchError: isError && state.dataUpdatedAt !== 0,
        isStale: isStale(query, options),
        refetch: this.refetch,
        remove: this.remove
      };
      return result;
    }
  }, {
    key: "updateResult",
    value: function updateResult(notifyOptions) {
      var _this7 = this;
      var prevResult = this.currentResult;
      var nextResult = this.createResult(this.currentQuery, this.options);
      this.currentResultState = this.currentQuery.state;
      this.currentResultOptions = this.options; // Only notify and update result if something has changed

      if (shallowEqualObjects(nextResult, prevResult)) {
        return;
      }
      this.currentResult = nextResult; // Determine which callbacks to trigger

      var defaultNotifyOptions = {
        cache: true
      };
      var shouldNotifyListeners = function shouldNotifyListeners() {
        if (!prevResult) {
          return true;
        }
        var notifyOnChangeProps = _this7.options.notifyOnChangeProps;
        if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !_this7.trackedProps.size) {
          return true;
        }
        var includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : _this7.trackedProps);
        if (_this7.options.useErrorBoundary) {
          includedProps.add('error');
        }
        return Object.keys(_this7.currentResult).some(function (key) {
          var typedKey = key;
          var changed = _this7.currentResult[typedKey] !== prevResult[typedKey];
          return changed && includedProps.has(typedKey);
        });
      };
      if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
        defaultNotifyOptions.listeners = true;
      }
      this.notify(_objectSpread(_objectSpread({}, defaultNotifyOptions), notifyOptions));
    }
  }, {
    key: "updateQuery",
    value: function updateQuery() {
      var query = this.client.getQueryCache().build(this.client, this.options);
      if (query === this.currentQuery) {
        return;
      }
      var prevQuery = this.currentQuery;
      this.currentQuery = query;
      this.currentQueryInitialState = query.state;
      this.previousQueryResult = this.currentResult;
      if (this.hasListeners()) {
        prevQuery == null ? void 0 : prevQuery.removeObserver(this);
        query.addObserver(this);
      }
    }
  }, {
    key: "onQueryUpdate",
    value: function onQueryUpdate(action) {
      var notifyOptions = {};
      if (action.type === 'success') {
        notifyOptions.onSuccess = !action.manual;
      } else if (action.type === 'error' && !isCancelledError(action.error)) {
        notifyOptions.onError = true;
      }
      this.updateResult(notifyOptions);
      if (this.hasListeners()) {
        this.updateTimers();
      }
    }
  }, {
    key: "notify",
    value: function notify(notifyOptions) {
      var _this8 = this;
      notifyManager.batch(function () {
        // First trigger the configuration callbacks
        if (notifyOptions.onSuccess) {
          var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
          (_this$options$onSucce = (_this$options = _this8.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, _this8.currentResult.data);
          (_this$options$onSettl = (_this$options2 = _this8.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, _this8.currentResult.data, null);
        } else if (notifyOptions.onError) {
          var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
          (_this$options$onError = (_this$options3 = _this8.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, _this8.currentResult.error);
          (_this$options$onSettl2 = (_this$options4 = _this8.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, _this8.currentResult.error);
        } // Then trigger the listeners

        if (notifyOptions.listeners) {
          _this8.listeners.forEach(function (listener) {
            listener(_this8.currentResult);
          });
        } // Then the cache listeners

        if (notifyOptions.cache) {
          _this8.client.getQueryCache().notify({
            query: _this8.currentQuery,
            type: 'observerResultsUpdated'
          });
        }
      });
    }
  }]);
  return QueryObserver;
}(Subscribable);
function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
export { QueryObserver };